import { render } from "./IconCross.vue?vue&type=template&id=00f862be"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconCross.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "00f862be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('00f862be', __exports__)) {
    api.reload('00f862be', __exports__)
  }
  
  module.hot.accept("./IconCross.vue?vue&type=template&id=00f862be", () => {
    api.rerender('00f862be', render)
  })

}


export default __exports__